<template>
  <section class="md:container md:gap-x-6 md:mx-auto xl:gap-x-8 border-app-green">
    <h2 class="mb-6 text-2xl font-bold leading-none uppercase">{{ ctas.title }}</h2>
    <div class="grid grid-cols-1 gap-4" :class="gridColsClass">
      <article v-for="(cta, idx) in ctas.ctas" :key="idx" class="group relative flex w-full">
        <MoleculeCallToAction :cta="cta" />
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  ctas: { title?: string; ctas: any[] }
}

const props = defineProps<Props>()

const gridColsClass = computed(() => {
  const count = props.ctas.ctas?.length ?? 0
  if (count >= 3) {
    return 'md:grid-cols-2 xl:grid-cols-3'
  }
  return 'md:grid-cols-2'
})
</script>
